//TODO: For now, we have only one page for the franchise using this template. In the future, if new pages come up, we can create dynamic pages under the franchise section.
import Theme from "@/components/Theme";
import Hero from "@/components/organisms/Hero";
import FeatureSectionTwocol from "@/components/organisms/FeatureSectionTwocol";
import BadgeSection from "@/components/organisms/BadgeSection";
import Trustpilot from "@/organisms/Trustpilot";
import Slider from "@/components/organisms/Slider";
import ServicesSectionTwoCol from "@/components/organisms/ServicesSectionTwoCol";
import RegistrationForm from "@/components/molecules/RegistrationForm";
import Discover from "@/components/organisms/Discover";
import * as puroClearn from "@/data/franchise/puroclean";
import Testimonial from "../../../components/organisms/Testimonial";

export async function getStaticProps() {
  const data = {
    marketing: puroClearn.marketing,
    content: puroClearn.content,
  };

  return {
    props: {
      data,
      pagename: "puroclean",
    },
  };
}

export default function PuroClean({ data, pagename }) {
  const seoData = data?.marketing;
  const pagedata = data?.content;
  const hero = (
    <Hero
      isFormStaticOnScroll
      heroTitle={pagedata.hero.title}
      heroContent={pagedata.hero.content}
      hasTrustpilot={pagedata.hero.hasTrustpilot}
      variant={pagedata.hero.variant}
      regFormOptions={pagedata.hero.regFormOptions}
      hasScrollToIntro={false}
    />
  );

  return (
    <Theme mainClassName="puroclean-page" hero={hero} seo={seoData}>
      <FeatureSectionTwocol
        isTitleMd
        title={pagedata.featureSectionTwocol1.title}
        image={pagedata.featureSectionTwocol1.image}
        bgColor={pagedata.featureSectionTwocol1.bgColor}
        content={pagedata.featureSectionTwocol1.content}
        isImageOnLeft={pagedata.featureSectionTwocol1.isImageOnLeft}
        hasTitleDot={pagedata.featureSectionTwocol1.hasTitleDot}
        ctaData={pagedata.featureSectionTwocol1.ctaData}
      />
      <ServicesSectionTwoCol
        bgColor={pagedata.servicesSectionTwoCol.bgColor}
        label={pagedata.servicesSectionTwoCol.label}
        title={pagedata.servicesSectionTwoCol.title}
        subText={pagedata.servicesSectionTwoCol.subText}
        listData={pagedata.servicesSectionTwoCol.listData}
        image={pagedata.servicesSectionTwoCol.image}
        contentData={pagedata.servicesSectionTwoCol.contentData}
      />
      <BadgeSection
        label={pagedata.badgeSection.label}
        title={pagedata.badgeSection.title}
        bgColor={pagedata.badgeSection.bgColor}
        image={pagedata.badgeSection.image}
        hasAestheticBg={pagedata.badgeSection.hasAestheticBg}
      />
      <Testimonial
        bgColor={pagedata.testimonial.bgColor}
        image={pagedata.testimonial.image}
        content={pagedata.testimonial.content}
        name={pagedata.testimonial.name}
        company={pagedata.testimonial.company}
      />
      <Slider
        data={pagedata.slider.data}
        variant={pagedata.slider.variant}
        title={pagedata.slider.title}
        subTitle={pagedata.slider.subTitle}
      />
      <Trustpilot
        title={pagedata.trustPilot.title}
        variant={pagedata.trustPilot.variant}
      />
      <RegistrationForm
        title={pagedata.miniRegister.title}
        content={pagedata.miniRegister.content}
        hasBusinessNameField={false}
        variant="mini"
        formUniqueName={`page-${pagename}-mini`}
      ></RegistrationForm>
      {/* TODO: Added default frachise pricing page link */}
      <Discover
        bgColor={pagedata.discover.bgColor}
        title={pagedata.discover.title}
        color={pagedata.discover.color}
        cta={pagedata.discover.cta}
        href={pagedata.discover.href}
      />
      <style jsx global>{`
        @media screen and (max-width: 768px) {
          .hero .formOnHero {
            background-color: #fff !important;
          }
          .has-static-form {
            padding-top: 80px !important;
          }
        }
        @media screen and (min-width: 768px) {
          .puroclean-page section:nth-of-type(1) figure {
            margin-right: 60px;
          }
        }
      `}</style>
    </Theme>
  );
}
